import styled from 'styled-components';
export const StyledBroadsiderSelectorModal = styled.div`
  z-index: 200;
  position: absolute;
  top: 100%;
  right: 150px;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  width: 360px;
  animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;

  .selector-contents {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 100%;
  }

  .selector-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .selector-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .selector-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .selector-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .selector-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  .selector-decorator {
    border-right: solid 2px ${({ theme }) => theme.borderDark};
    border-left: solid 2px ${({ theme }) => theme.borderDark};
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    background: ${({ theme }) => theme.selection};
    height: ${({ theme }) => theme.frameWidth};
    width: ${({ theme }) => theme.selectableButtonSize};
  }
  .selector-background {
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.background};
  }

  .selector-title-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
    padding: 0 20px;
    height: 26px;
    background: ${({ theme }) => theme.menuTitle};
  }

  .selector-title {
    text-transform: uppercase;
    background: ${({ theme }) => theme.background};
    height: 100%;
    padding: 0 6px;
    font-family: "BebasNeue";
    font-size: 2em;
    font-weight: 500;
    color: white;
    line-height: 1;
  }

  .selector-avatars-holder {
    padding: 16px 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 12px;
    overflow-x: auto;
  }

  .selector-broadsider-info {
    padding-left: 20px;
    padding-right: 20px;
    div {
      text-align: start !important;
    }
    margin-top: 12px;
  }

  .selector-traits-holder {
    border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
  }

  .selector-traits-decorator {
    border-right: solid 2px ${({ theme }) => theme.borderDark};
    border-left: solid 2px ${({ theme }) => theme.borderDark};
    width: ${({ theme }) => theme.avatarSize};
    background: white;
    height: ${({ theme }) => theme.frameWidth};
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: 20px;
    margin-right: 20px;
  }

  .selector-opensea-button-holder {
    padding: 18px;
    padding-top: 0;
  }

  .selector-opensea-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;
